import Content from "../common/Content";
import Footer from "../common/Footer";
import Header from "../common/Header";
import { API } from "../../helper/Api";
import { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RotatingLines } from "react-loader-spinner";
import $ from "jquery";
import SessionHandler from "../common/SessionHandler";
import { useRole } from "../contextApi/RoleContext";
import { Link, useNavigate } from "react-router-dom";
import ErrorPopup from "../common/ErrorPopup";


export default function UpcChecker(props) {

  const { setRole, role, setPermission, permission } = useRole();
  const [photos, setPhotos] = useState([]);
  const [items, setItems] = useState([]);
  const [mainData, setmainData] = useState([]);
  const [page, setPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pending, setPending] = useState(false);
  const [storeCurrPerm, setStoreCurrPerm] = useState();
  const [upcCode, setUpcCode] = useState();
  const [showPopup, setShowPopup] = useState(false);
   ////validation 
   const [errors, setErrors] = useState({
    upc: '',
   
  });
  const navigate = useNavigate();
  ///FORM SUBMIT///
  const handleFormSubmit = (e) => {
    e.preventDefault();
    if(!upcCode){
      setErrors({upc:'Upc is required..'});
      setShowPopup(true);
    }else{
      getCatalog();
    }
    

  };
  const labelStyles = {
    fontWeight: "600",
    marginBottom: "8px",
    fontSize: "14px",
  };

  useEffect(() => {
    const currentPagePerm = permission.find((item) => item.category_id === "3");
    setStoreCurrPerm(currentPagePerm);
  }, []);

  const closePopup = () => {
    setShowPopup(false);
  };
  const getCatalog = () => {
    setPending(true);
    API.fetchUpc(upcCode)
      .then((datas) => {
        const totalRecords = datas.ApiDocument.TotalRecords;
        setTotalRecords(totalRecords);
        if(totalRecords > 0 ){

          // toast.success("This UPC already exists in the system", {
          //   position: "top-center",
          //   autoClose: 5000,
          //   hideProgressBar: false,
          //   closeOnClick: true,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "colored",
          // });


          const items = datas.ApiDocument.Response.Styles.flatMap(
            (style) => style
          );

          setItems(items);
        }else{
          navigate("/add-new-catalog?upc=" + upcCode);
        }
        setPending(false);

      })
      .catch((err) => console.log(err));
  };

console.log(items.length);
  return (

    <>
        <ToastContainer
        position="top-center"
        autoClose={500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
{showPopup && <ErrorPopup errors={errors} onClose={closePopup} />}
    <div className="main-panel">
      <div className="content-wrapper">
        <div className="container mainbody1">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h2 className="form-header">Enter Your UPC</h2>
            <Link to="/catalog-list" className="backButton">
              <i class="mdi mdi-arrow-left"></i>Back
            </Link>
          </div>
          {pending ? (
                
                <div className="loader">
                  <RotatingLines
                    visible={true}
                    height="96"
                    width="96"
                    strokeColor="grey"
                    strokeWidth="2"
                    animationDuration="0.75"
                    ariaLabel="rotating-lines-loading"
                  />
                </div>
              ) : (
          <form onSubmit={handleFormSubmit} style={{ marginTop: "15px" }}>
            {/* Role label in a separate row */}
            <div className="form-group">
              {/* <label htmlFor="newrole" style={labelStyles}>
                UPC:<span className="requireds">*</span>
              </label> */}
              <input
                id="upc"
                type="text"
                placeholder="Enter Upc"
                value={upcCode}
                onChange={(e) => setUpcCode(e.target.value)}
                style={{
                  width: "100%",
                  padding: "8px",
                  marginBottom: "15px",
                  borderRadius: "4px",
                  border: "1px solid #ced4da",
                  fontSize: "14px",
                }}
                minlength="8"
                maxlength="18"
              />
            </div>

            {/* Submit button */}
            <div style={{ display: "flex", gap: "5px" }}>
              <button
                type="submit"
                className="submit-btn"
                style={{
                  padding: "10px 20px",
                  border: "none",
                  backgroundColor: "rgb(108,117,125)",
                  color: "#fff",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "16px",
                }}
                onClick={() => navigate("/catalog-list")}
              >
                CANCEL
              </button>
              <button
                type="submit"
                className="submit-btn"
                style={{
                  padding: "10px 20px",
                  border: "none",
                  backgroundColor: "#007bff",
                  color: "#fff",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "16px",
                }}
              >
                Submit
              </button>
            </div>
          </form>
                        )}

        </div>

        {totalRecords > 0 ? (
                
            <div class="Card_contend">
                <div>
                  <h1>Result :-</h1>
                    <table class="table table-bordered">
                    <thead>
                        <tr>
                          <th style={{ fontWeight: "bold", color: "#665d5d" }}>
                            CLU
                          </th>
                          <th style={{ fontWeight: "bold", color: "#665d5d" }}>
                            DESCRIPTION
                          </th>
                          <th style={{ fontWeight: "bold", color: "#665d5d" }}>
                            COST
                          </th>
                          <th style={{ fontWeight: "bold", color: "#665d5d" }}>
                            PRICE
                          </th>
                          <th style={{ fontWeight: "bold", color: "#665d5d" }}>
                            VENDOR
                          </th>
                          <th
                            style={{
                              fontWeight: "bold",
                              color: "#665d5d",
                              textAlign: "center",
                            }}
                          >
                            NSO
                          </th>
                          <th style={{ fontWeight: "bold", color: "#665d5d" }}>
                            UPC
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {items.map((item, index) => (
                          <tr>
                            <td>
                              {item.Items[0].CLU ? (
                                <a
                                  href={`catalog-price-update?id=${item.StyleNo}`}
                                  value={item.StyleNo}
                                >
                                  {item.Items[0].CLU}
                                </a>
                              ) : (
                                ""
                              )}
                            </td>
                            <td>
                              {item.StoreDescription
                                ? item.StoreDescription
                                : ""}
                            </td>
                            <td>
                              $
                              {item.OrderCost
                                ? item.OrderCost.toFixed(2)
                                : "0.00"}
                            </td>
                            <td>
                              $
                              {item.Items[0].BasePrice
                                ? item.Items[0].BasePrice.toFixed(2)
                                : "0.00"}
                            </td>
                            <td>
                              {item.PrimaryVendorIdentifier
                                ? `${item.Brand} (#${item.PrimaryVendorIdentifier})`
                                : ""}
                            </td>
                            <td class="nso_details">
                              {item.Custom.CustomFlag3 == true ? (
                                <span class="mdi mdi-checkbox-marked-circle nso_true"></span>
                              ) : (
                                ""
                              )}
                            </td>
                            <td>
                              {item.Items[0].UPC ? item.Items[0].UPC : "-"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                </div>

            </div>
              ) : ''}

      </div>
    </div>
    </>
  );
}

